import { Link } from 'react-router-dom';
import Meta from '../components/Meta';

export default function NotFound() {
  return (
    <>
      <Meta 
        title="Siden blev ikke fundet" 
        description="Fejl 404: Siden blev ikke fundet. Gå tilbage til forsiden eller udforsk vores ydelser."
      />

      <section className="min-h-[75vh] flex items-center justify-center bg-brand-light px-6 py-12">
        <div className="max-w-xl w-full bg-white p-10 sm:p-12 rounded-2xl border border-gray-100 shadow-sm text-center space-y-8">
          <div className="inline-flex items-center justify-center h-20 w-20 rounded-full bg-brand-blue/10 text-brand-blue text-4xl">
            <i className="fa-regular fa-compass-slash" />
          </div>
          
          <div className="space-y-3">
            <span className="text-xs font-bold uppercase tracking-widest text-brand-blue">Fejl 404</span>
            <h1 className="text-3xl font-bold text-brand-dark tracking-tight">
              Siden blev ikke fundet
            </h1>
            <p className="text-gray-600 text-sm leading-relaxed max-w-md mx-auto">
              Den side, du leder efter, findes desværre ikke. Den kan være blevet slettet, have fået nyt navn, eller være midlertidigt utilgængelig.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Link 
              to="/" 
              className="bg-brand-dark hover:bg-brand-blue text-white px-6 py-3 rounded-md font-semibold transition-colors text-center"
            >
              Gå til forsiden
            </Link>
            <Link 
              to="/kontakt" 
              className="bg-white hover:bg-gray-50 text-brand-dark border border-gray-200 px-6 py-3 rounded-md font-semibold transition-colors text-center"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
